import { render, staticRenderFns } from "./HeadquartersImport.vue?vue&type=template&id=ba490fb2&scoped=true&"
import script from "./HeadquartersImport.vue?vue&type=script&lang=js&"
export * from "./HeadquartersImport.vue?vue&type=script&lang=js&"
import style0 from "./HeadquartersImport.vue?vue&type=style&index=0&id=ba490fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba490fb2",
  null
  
)

component.options.__file = "HeadquartersImport.vue"
export default component.exports